/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_apex_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Find the highest-scoring F1 Fantasy team combinations for the upcoming race. The optimizer runs every valid lineup within your budget and ranks by predicted points — set your race, stage, and budget to see the top picks instantly.`)
};

const es_f1_apex_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encuentra las combinaciones de equipo F1 Fantasy con mayor puntuación para la próxima carrera. El optimizador evalúa cada alineación válida dentro de tu presupuesto y ordena por puntos predichos — configura tu carrera, etapa y presupuesto para ver los mejores picks al instante.`)
};

const de_f1_apex_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finde die punktestärksten F1 Fantasy Team-Kombinationen für das kommende Rennen. Der Optimizer prüft jedes gültige Lineup innerhalb deines Budgets und sortiert nach prognostizierten Punkten — stelle Rennen, Stage und Budget ein, um die Top-Picks sofort zu sehen.`)
};

const nl_f1_apex_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vind de hoogst scorende F1 Fantasy-teamcombinaties voor de komende race. De optimizer doorloopt elke geldige opstelling binnen je budget en rangschikt op verwachte punten — stel je race, fase en budget in om direct de topkeuzes te zien.`)
};

const fr_f1_apex_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trouvez les meilleures combinaisons d’équipes F1 Fantasy pour la prochaine course. L’optimiseur évalue chaque composition valide dans votre budget et classe par points prédits — définissez votre course, étape et budget pour voir les meilleurs choix instantanément.`)
};

const it_f1_apex_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trova le combinazioni di team F1 Fantasy con il punteggio più alto per la prossima gara. L’ottimizzatore valuta ogni formazione valida entro il tuo budget e classifica per punti previsti — imposta gara, fase e budget per vedere le migliori scelte all’istante.`)
};

const pt_br2_f1_apex_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encontre as combinações de equipe F1 Fantasy com maior pontuação para a próxima corrida. O otimizador avalia cada escalação válida dentro do seu orçamento e classifica por pontos previstos — defina sua corrida, estágio e orçamento para ver as melhores escolhas instantaneamente.`)
};

const pt_f1_apex_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encontre as combinações de equipa F1 Fantasy com maior pontuação para a próxima corrida. O otimizador avalia cada alinhamento válido dentro do seu orçamento e ordena por pontos previstos — defina a sua corrida, fase e orçamento para ver as melhores escolhas instantaneamente.`)
};

const ja_f1_apex_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`次のレースで最高得点のF1ファンタジーチームの組み合わせを見つけます。予算内のすべての有効なラインナップを計算し、予測ポイントでランク付け。レース、ステージ、予算を設定して最適なピックを即座に確認。`)
};

const zh_f1_apex_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为即将到来的比赛找到最高得分的F1 Fantasy车队组合。优化器在您的预算内运行每个有效阵容并按预测积分排名 — 设置您的比赛、阶段和预算，即刻查看最优选择。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_apex_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_apex_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_apex_intro", locale)
	if (locale === "en") return en_f1_apex_intro(inputs)
	if (locale === "es") return es_f1_apex_intro(inputs)
	if (locale === "de") return de_f1_apex_intro(inputs)
	if (locale === "nl") return nl_f1_apex_intro(inputs)
	if (locale === "fr") return fr_f1_apex_intro(inputs)
	if (locale === "it") return it_f1_apex_intro(inputs)
	if (locale === "pt-BR") return pt_br2_f1_apex_intro(inputs)
	if (locale === "pt") return pt_f1_apex_intro(inputs)
	if (locale === "ja") return ja_f1_apex_intro(inputs)
	return zh_f1_apex_intro(inputs)
};